import { FaIcon, faSaveSolid } from '@/lib/fa'
import React from 'react'

const AddBusinessFooter = ({ onSave }: { onSave: any }) => {
  return (
    <div className="tw-sticky tw-bottom-0 tw-z-[100] tw-flex tw-w-full tw-justify-end tw-border-t tw-border-gray-300 tw-bg-white tw-p-4">
      <button
        className="tw-flex tw-items-center tw-gap-4 tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white"
        onClick={() => onSave()}
      >
        <FaIcon icon={faSaveSolid} />
        <p>Zapisz</p>
      </button>
    </div>
  )
}

export default AddBusinessFooter
